const TabNavStyles = Object.freeze({
  root: { display: 'flex', justifyContent: 'space-between' },
  navContainer: { display: 'flex', alignItems: 'center' },
  navItem: { padding: 16 },
});

export default TabNavStyles;
